/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('nodeMoveModal', ['nodeModalAction', 'confirmAction', '$translate', 'SyncAndShareNode', '$q',
        function(nodeModalAction, confirmAction, $translate, SyncAndShareNode, $q) {
            var openModal = function($scope) {
                nodeModalAction($scope, {
                    modalController: "CopyMoveController",
                    modalType: "confirm",
                    modalAction: "move",
                    modalBodyTemplate: "modals/actions/transfer",
                    modalFooterTemplate: "nodes/_transfer_modal_footer",
                    modalTitle: 'Move',
                    modalActionButton: $translate.instant('Move'),
                    modalNotifications: true
                });
            };
            
            return function($scope) {
                var
                    elements = $scope.node ? [$scope.node] : $scope.selectedNodes,
                    confirmTextsArray = [],
                    promises = [],
                    shares;
                
                angular.forEach(elements, function(node) {
                    if(node['is_directory'] && !node['is_shared'] && node['type'] === 'sync-and-share') {
                        promises.push(SyncAndShareNode.get({uuid: node.uuid, fields: 'has_shared_child_nodes'}, function(data) {
                            node['has_shared_child_nodes'] = data['has_shared_child_nodes'];
                        }).$promise);
                    }
                });
                
                $q.all(promises).then(function() {
                    shares = elements.filter(function(e) {
                        return e['is_directory'] && (e['is_shared'] || e['has_shared_child_nodes']);
                    });

                    if(shares.length > 0) { // TODO: Consider removing OR altering the confirmation message (non-conflict moves does not affect the shares)
                        if(shares.length == 1) {
                            confirmTextsArray = ["You are moving a shared folder", "Moving this folder will remove sharing for all users and will cause the folder to be removed from any of their synced devices. Are you sure you want to move this shared folder?", "Continue", "Cancel"]
                        } else {
                            var folderNames = shares.map(function(s) {
                                return s.name;
                            }).join(", ");
                            confirmTextsArray = ["You are moving shared folders", "Moving folders '%{folder_names}' will remove their sharing for all users and will cause the folders to be removed from any of their synced devices. Are you sure you want to move these shared folders?", "Continue", "Cancel"]
                        }
                        $translate(confirmTextsArray, shares.length > 1 ? {folder_names: folderNames} : {}).then(function(dictionery) {
                            confirmAction({}, {
                                confirmTitle: dictionery[confirmTextsArray[0]],
                                confirmBody: dictionery[confirmTextsArray[1]],
                                confirmSubmit: dictionery[confirmTextsArray[2]],
                                confirmCancel: dictionery[confirmTextsArray[3]]
                            }).then(function() {
                                openModal($scope);
                            })
                        });
                    } else {
                        openModal($scope);
                    }
                });
            };
        }]);
